import Table from "@material-ui/core/Table";
import React, { Fragment } from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { useTranslation } from "react-i18next";
import FlagIcon from "../../../components/FlagIcon";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import withStyles from "@material-ui/core/styles/withStyles";
import { formatDateTime } from "../../../utils/Formatter";
import StaticClassifierRepository from "../../../repositories/StaticClassifierRepository";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const PairViewRow = ({ item }) => {
  const classifierRepository = new StaticClassifierRepository();
  const { t } = useTranslation();

  const formatDirectionType = (value) => {
    return t(classifierRepository.getMovingDirectionNameById(value));
  };

  return (
    <TableRow>
      <StyledTableCell>
        {formatDirectionType(item.NewValue.DirectionType)}
      </StyledTableCell>
      <StyledTableCell>{item.Id}</StyledTableCell>
      <StyledTableCell>{formatDateTime(item.EventDate)}</StyledTableCell>
      <StyledTableCell>
        <FlagIcon
          code={item.NewValue.NumberPlateOrigin.toLowerCase()}
          size={"lg"}
        />{" "}
        {item.NewValue.NumberPlate}
      </StyledTableCell>
      <StyledTableCell>{item.NewValue.ParkingZoneName}</StyledTableCell>
    </TableRow>
  );
};

export const ListView = ({ list }) => {
  const { t } = useTranslation();

  return (
    <Table>
      <TableHead>
        <TableRow>
          <StyledTableCell></StyledTableCell>
          <StyledTableCell>{t("Event id")}</StyledTableCell>
          <StyledTableCell>{t("Event date")}</StyledTableCell>
          <StyledTableCell>{t("Number plate")}</StyledTableCell>
          <StyledTableCell>{t("Parking zone")}</StyledTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {list.map((row, index) => {
          return <PairViewRow key={index} item={row} />;
        })}
      </TableBody>
    </Table>
  );
};

export const PairView = ({ list }) => {
  const { t } = useTranslation();

  return (
    <Table>
      <TableHead>
        <TableRow>
          <StyledTableCell></StyledTableCell>
          <StyledTableCell>{t("Event id")}</StyledTableCell>
          <StyledTableCell>{t("Event date")}</StyledTableCell>
          <StyledTableCell>{t("Number plate")}</StyledTableCell>
          <StyledTableCell>{t("Parking zone")}</StyledTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {list.map((row, index) => {
          return (
            <Fragment key={index}>
              <PairViewRow item={row.In} />
              <PairViewRow item={row.Out} />
            </Fragment>
          );
        })}
      </TableBody>
    </Table>
  );
};
